<template>
  <div>
    <div class="properties-carousel-toolbar flex-container align-justify align-middle" v-if="properties.length > 1">
      <button @click="prev" title="previous" class="properties-carousel-toolbar-button properties-carousel-toolbar-button">
        <div class="-scale-1">
          <svg style="display: block" width="32" height="32" viewBox="0 0 64 64">
            <use xlink:href="#arrow-right-swiper"/>
          </svg>
        </div>
      </button>
      <span><span v-text="activeIndex + 1"></span> of <span v-text="properties.length"></span></span>
      <button @click="next" title="next" class="properties-carousel-toolbar-button">
        <svg style="display: block" width="32" height="32" viewBox="0 0 64 64">
          <use xlink:href="#arrow-right-swiper"/>
        </svg>  
      </button>
    </div>
    <property-card v-bind="properties[activeIndex]" :horizontal="true" />
  </div>
</template>

<script>
import PropertyCard from './property-card.vue'
export default {
  components: { PropertyCard },
  name: 'PropertiesCarousel',
  props: {
    properties: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      activeIndex: 0,
    }
  },
  methods: {
    prev() {
      this.activeIndex = (this.activeIndex + this.properties.length - 1) % this.properties.length
    },
    next() {
      this.activeIndex = (this.activeIndex + 1) % this.properties.length
    }
  }
}
</script>
